<template>

    <div>
  
        <!-- İlgili Siparişler -->
        <campaign-list :tableColumns="tableColumns" :params="params" :addBtnShow="addBtnControl" ></campaign-list>
    
    </div>
  </template>
  
  <script>
  import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BTableLite, VBTooltip
  } from 'bootstrap-vue'
  import CampaignList from '../campaign/Links.vue';
  
  export default {
    components: {
      
      BCard,
      BRow,
      BCol,
      BFormInput,
      BButton,
      BTable,
      BMedia,
      BAvatar,
      BLink,
      BBadge,
      BDropdown,
      BDropdownItem,
      BPagination,
      BFormCheckbox,
      BTableLite,
  
      CampaignList,
    },
    directives: {
      'b-tooltip': VBTooltip
    },
    data() {
        return {
            tableColumns : [
                { key: 'id', sortable: true },
                { key: 'campaign_name', label: 'Paylaşım', sortable: true },
                { key: 'description',label:'Mesaj İçeriği', sortable: false },
                { key: 'event_count',label:'Ziyaret', sortable: false },
                { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
                { key: 'order_count',label:'Sipariş Adedi', sortable: false },
                { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
                { key: 'status', label: 'Durum'},
                { key: 'actions', label: 'Detay'},
            ],
            params:{
                filter:{
                    type:2,
                },
                source: 'list'
            }
        }
    },
    computed: {
      addBtnControl() {
        return this.$store.state.user.userData.permissions?.includes('firma_paylasimi.sms_ekleyebilir_duzenleyebilir');
      }
    },
    mounted(){
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  </style>
  